import { createSelector, createFeatureSelector } from '@ngrx/store';
import { selectCurrentAttachments } from './attachments.selector';
import { IAttachmentState } from '../attachment.reducer';

export const selectAttachment = createFeatureSelector('attachment');
export const selectCurrentAttachment = createSelector(
  selectCurrentAttachments,
  selectAttachment,
  (currentAttachments, attachment: IAttachmentState) => {
    const attachmentId = attachment.currentAttachmentId;
    let result;
    currentAttachments.forEach((attachment) => {
      if (attachment.globalId
        && (attachment.globalId.indexOf(attachmentId) >= 0)) {
        result = attachment;
      }
    });
    return result;
  }
);
